/**
 * The public setting keys this app reads, mirroring `SettingKeys` on the server. Constants so a
 * renamed key is one edit here rather than a string scattered through the pages.
 *
 * `companyAbout`, `contactAddress` and `contactWorkingHours` are bilingual: they arrive under
 * `PublicSettings.localized` and are read with `readLocalizedSetting`, not from the value map.
 */
export const SettingKeys = {
    companyDisplayName: 'Company.DisplayName',
    companyAbout: 'Company.About',
    contactPhone: 'Contact.Phone',
    contactWhatsApp: 'Contact.WhatsApp',
    contactEmail: 'Contact.Email',
    contactAddress: 'Contact.Address',
    contactWorkingHours: 'Contact.WorkingHours',
    publicSiteDefaultLanguage: 'PublicSite.DefaultLanguage',
    /** Arrives as the string `"true"` — `settings[key] ?? false` is truthy for `"false"`. */
    publicSiteAppointmentsEnabled: 'PublicSite.AppointmentsEnabled',
    appointmentsBookingHorizonDays: 'Appointments.BookingHorizonDays',
    publicSiteInstagramUrl: 'PublicSite.InstagramUrl',
    publicSiteTelegramUrl: 'PublicSite.TelegramUrl'
} as const;
